import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { Cart, Folder, Plus } from 'iconoir-react';

import { useMobileGlobalSearch } from '../../context/MobileGlobalSearchContext';
import DossierCreateDrawer from '../DossierCreateDrawer';
import MobileListSearchBar from '../MobileListSearchBar';
import {
  $FooterCreateButton,
  $FooterCreateIcon,
  $FooterCreateLabel,
  $FooterNav,
  $FooterNavItem,
  $FooterNavIcon,
  $FooterNavLabel,
  $FooterNavList,
  $FooterSearchSection,
  $MobileFooterChrome,
} from './MobileFooterNav.styles';
import messages from './messages';

const MobileFooterNav = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState(false);
  const { searchQuery, setSearchQuery, handleSearchChange, handleSearchClear } =
    useMobileGlobalSearch();

  const isCommandeActive = location.pathname.startsWith('/commande');
  const isDossierActive = location.pathname.startsWith('/dossier');

  useEffect(() => {
    setIsCreateDrawerOpen(false);
  }, [location.pathname]);

  return (
    <>
      <$MobileFooterChrome>
        <$FooterSearchSection>
          <MobileListSearchBar
            value={searchQuery}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
            onScanResult={setSearchQuery}
            hasTopMargin={false}
            dataTestId="mobile-global-search"
          />
        </$FooterSearchSection>

        <$FooterNav aria-label={intl.formatMessage({ id: 'mobileFooterNav.aria', defaultMessage: 'Navigation principale' })}>
          <$FooterNavList>
          <$FooterNavItem
            type="button"
            $isActive={isDossierActive}
            onClick={() => navigate('/dossier')}
            aria-current={isDossierActive ? 'page' : undefined}
            data-testid="mobile-footer-nav-dossier"
          >
            <$FooterNavIcon aria-hidden>
              <Folder width={22} height={22} strokeWidth={1.75} />
            </$FooterNavIcon>
            <$FooterNavLabel>{intl.formatMessage(messages.dossier)}</$FooterNavLabel>
          </$FooterNavItem>

          <$FooterCreateButton
            type="button"
            $isActive={isCreateDrawerOpen}
            onClick={() => setIsCreateDrawerOpen(true)}
            aria-expanded={isCreateDrawerOpen}
            aria-haspopup="dialog"
            data-testid="mobile-footer-nav-create"
          >
            <$FooterCreateIcon aria-hidden>
              <Plus width={24} height={24} strokeWidth={2} />
            </$FooterCreateIcon>
            <$FooterCreateLabel>{intl.formatMessage(messages.create)}</$FooterCreateLabel>
          </$FooterCreateButton>

          <$FooterNavItem
            type="button"
            $isActive={isCommandeActive}
            onClick={() => navigate('/commande')}
            aria-current={isCommandeActive ? 'page' : undefined}
            data-testid="mobile-footer-nav-commande"
          >
            <$FooterNavIcon aria-hidden>
              <Cart width={22} height={22} strokeWidth={1.75} />
            </$FooterNavIcon>
            <$FooterNavLabel>{intl.formatMessage(messages.commande)}</$FooterNavLabel>
          </$FooterNavItem>
        </$FooterNavList>
        </$FooterNav>
      </$MobileFooterChrome>

      <DossierCreateDrawer
        isOpen={isCreateDrawerOpen}
        onClose={() => setIsCreateDrawerOpen(false)}
      />
    </>
  );
};

export default MobileFooterNav;
